import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import formatName from 'I18n/utils/formatName';
import styled, { theme } from 'academy-common-lib/utils/Styling';
import UIList from 'UIComponents/list/UIList';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import uniq from 'hs-lodash/uniq';
import { useMemo, useState } from 'react';
import { usePlaylist, useUserOwnsPlaylist } from '..';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LabelContainer = styled.small.attrs({
  'data-test-id': 'created-by',
  role: 'label'
}).withConfig({
  displayName: "PlaylistCreatedAndAssignedByLabel__LabelContainer",
  componentId: "sc-1j7wlbg-0"
})(["display:block;color:", ";"], theme.colors.EERIE);
export const CreatedByLabel = ({
  playlist: {
    ownerUser,
    id
  }
}) => {
  const isOwnedByUser = useUserOwnsPlaylist(id);
  if (isOwnedByUser) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.myPlaylists.createdByMe"
    });
  } else {
    const {
      firstName,
      lastName
    } = ownerUser;
    const displayName = formatName({
      firstName,
      lastName
    });
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.myPlaylists.createdBy",
      options: {
        user: displayName
      }
    });
  }
};
const AssignorsPopup = ({
  displayNames
}) => {
  return /*#__PURE__*/_jsx(UIList, {
    childClassName: "m-y-5",
    firstChildClassName: "",
    lastChildClassName: "",
    style: {
      padding: 24
    },
    children: displayNames.map((displayName, index) => /*#__PURE__*/_jsx("span", {
      style: {
        color: theme.colors.OBSIDIAN,
        fontWeight: 400,
        fontSize: 14
      },
      children: displayName
    }, `assignor_popup_${index}`))
  });
};
const AssignorsPopupButton = styled(UIButton).attrs({
  use: 'link'
}).withConfig({
  displayName: "PlaylistCreatedAndAssignedByLabel__AssignorsPopupButton",
  componentId: "sc-1j7wlbg-1"
})(["color:", " !important;*{font-weight:400;-webkit-font-smoothing:auto;-moz-osx-font-smoothing:auto;}"], theme.colors.EERIE);
const AssignedByLabel = ({
  playlist: {
    assignments
  }
}) => {
  const [isMoreAssignorsPopoverOpen, setIsMoreAssignorsPopoverOpen] = useState(false);
  const assignorDisplayNames = useMemo(() => uniq(assignments.map(({
    assignorUser: {
      firstName,
      lastName
    }
  }) => formatName({
    firstName,
    lastName
  }))), [assignments]);
  const displayName = assignorDisplayNames[0];
  const onMoreAssignorsLinkClick = e => {
    e.preventDefault();
    e.stopPropagation();
    setIsMoreAssignorsPopoverOpen(true);
  };
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "learningCenter.myPlaylists.assignedBy",
    options: {
      user: assignorDisplayNames.length > 1 ? /*#__PURE__*/_jsx(UIPopover, {
        content: /*#__PURE__*/_jsx(AssignorsPopup, {
          displayNames: assignorDisplayNames
        }),
        onOpenChange: e => setIsMoreAssignorsPopoverOpen(e.target.value),
        open: isMoreAssignorsPopoverOpen,
        use: "longform",
        children: /*#__PURE__*/_jsxs(AssignorsPopupButton, {
          onClick: onMoreAssignorsLinkClick,
          children: [displayName, /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myPlaylists.otherCount",
            options: {
              count: assignorDisplayNames.length - 1
            }
          })]
        })
      }) : displayName
    }
  });
};
export const PlaylistCreatedAndAssignedByLabel = _ref => {
  let {
      playlistId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    playlist
  } = usePlaylist(playlistId);
  if (!playlist) return null;
  return /*#__PURE__*/_jsx(LabelContainer, Object.assign({}, props, {
    children: playlist.assignments.length ? /*#__PURE__*/_jsx(AssignedByLabel, {
      playlist: playlist
    }) : /*#__PURE__*/_jsx(CreatedByLabel, {
      playlist: playlist
    })
  }));
};
export default PlaylistCreatedAndAssignedByLabel;